import { defineMessages } from "@ai360/core/intl";

export const messages = defineMessages({
    addEventTooltip: {
        id: "eventModule.eventInfo.addEventTooltip",
        defaultMessage: "Add Event",
    },
    application: {
        id: "eventModule.eventInfo.application",
        defaultMessage: "Application",
    },
    batchCopySummaryLine2: {
        id: "eventModule.eventInfo.batchCopySummaryLine2",
        defaultMessage: "Copying {batchSize} Events",
    },
    batchSummaryLine1: {
        id: "eventModule.eventInfo.batchSummaryLine1",
        defaultMessage: "Create Events",
    },
    batchSummaryLine2: {
        id: "eventModule.eventInfo.batchSummaryLine2",
        defaultMessage: "Batching {batchSize} Events",
    },
    cloudCoverPlaceholderText: {
        id: "eventModule.eventInfo.cloudCoverPlaceholderText",
        defaultMessage: "Cloud Cover (%)",
    },
    cropCyclePlaceholderText: {
        id: "eventModule.eventInfo.cropCyclePlaceholderText",
        defaultMessage: "Crop Cycle",
    },
    depthColLabel: {
        id: "eventModule.eventInfo.depthColLabel",
        defaultMessage: "Depth",
    },
    displayLayerPlaceholderTxt: {
        id: "eventModule.eventInfo.displayLayerPlaceholderTxt",
        defaultMessage: "Display Layer",
    },
    endDatePlaceholderText: {
        id: "eventModule.eventInfo.endDatePlaceholderText",
        defaultMessage: "End Date",
    },
    equipmentBucketTitle: {
        id: "eventModule.eventInfo.equipmentBucketTitle",
        defaultMessage: "Equipment",
    },
    errorGettingAutoTracePreferences: {
        id: "eventModule.eventInfo.errorGettingAutoTracePreferences",
        defaultMessage: "Error retrieving auto trace preferences.",
    },
    errorSavingAutoTracePreferences: {
        id: "eventModule.eventInfo.errorSavingAutoTracePreferences",
        defaultMessage: "Error saving auto trace preferences.",
    },
    eventNamePlaceholderText: {
        id: "eventModule.eventInfo.eventNamePlaceholderText",
        defaultMessage: "Event Name",
    },
    findEquipmentPlaceholderText: {
        id: "eventModule.eventInfo.findEquipmentPlaceholderText",
        defaultMessage: "Find Equipment",
    },
    findPeoplePlaceholderText: {
        id: "eventModule.eventInfo.findPeoplePlaceholderText",
        defaultMessage: "Find People",
    },
    GDDPlaceholderText: {
        id: "eventModule.eventInfo.GDDPlaceholderText",
        defaultMessage: "GDD",
    },
    generalInfoBucketTitle: {
        id: "eventModule.eventInfo.generalInfoBucketTitle",
        defaultMessage: "General Information",
    },
    generalNotesBucketTitle: {
        id: "eventModule.eventInfo.generalNotesBucketTitle",
        defaultMessage: "General Notes",
    },
    harvest: {
        id: "eventModule.eventInfo.harvest",
        defaultMessage: "Harvest",
    },
    hasTimeLabel: {
        id: "eventModule.eventInfo.hasTimeLabel",
        defaultMessage: "Include Time",
    },
    humidityPlaceholderText: {
        id: "eventModule.eventInfo.humidity",
        defaultMessage: "Humidity (%)",
    },
    idColLabel: {
        id: "eventModule.eventInfo.idColLabel",
        defaultMessage: "ID",
    },
    manualZones: {
        id: "eventModule.eventInfo.manualZones",
        defaultMessage: "Manual Zones",
    },
    notesPlaceholderText: {
        id: "eventModule.eventInfo.notesPlaceholderText",
        defaultMessage: "Notes",
    },
    peopleBucketTitle: {
        id: "eventModule.eventInfo.peopleBucketTitle",
        defaultMessage: "People",
    },
    precipitationPlaceholderText: {
        id: "eventModule.eventInfo.precipitationPlaceholderText",
        defaultMessage: "Precipitation (in)",
    },
    ratingTxt: {
        id: "eventModule.eventInfo.ratingTxt",
        defaultMessage: "Rating",
    },
    seasonPlaceholderText: {
        id: "eventModule.eventInfo.seasonPlaceholderText",
        defaultMessage: "Season",
    },
    soilCompactionPlaceholderText: {
        id: "eventModule.eventInfo.soilCompactionPlaceholderText",
        defaultMessage: "Soil Compaction",
    },
    soilCondPlaceholderText: {
        id: "eventModule.eventInfo.soilCondPlaceholderText",
        defaultMessage: "General",
    },
    soilInfoBucketTitle: {
        id: "eventModule.eventInfo.soilInfoBucketTitle",
        defaultMessage: "Soil Conditions",
    },
    startDatePlaceholderText: {
        id: "eventModule.eventInfo.startDatePlaceholderText",
        defaultMessage: "Start Date",
    },
    tempPlaceholderText: {
        id: "eventModule.eventInfo.tempPlaceholderText",
        defaultMessage: "Temp (F)",
    },
    timingInfoBucketTitle: {
        id: "eventModule.eventInfo.timingInfoBucketTitle",
        defaultMessage: "Timing Info",
    },
    unimplementedFormLabel: {
        id: "eventModule.eventInfo.unimplementedFormLabel",
        defaultMessage: "Unknown",
    },
    weatherInfoBucketTitle: {
        id: "eventModule.eventInfo.weatherInfoBucketTitle",
        defaultMessage: "Weather Conditions",
    },
    weatherPlaceholderText: {
        id: "eventModule.eventInfo.weatherPlaceholderText",
        defaultMessage: "General Weather",
    },
    windDirectionPlaceholderText: {
        id: "eventModule.eventInfo.windDirection",
        defaultMessage: "Wind Direction",
    },
    windSpeedPlaceholderText: {
        id: "eventModule.eventInfo.windSpeedPlaceholderText",
        defaultMessage: "Wind Speed (mph)",
    },
    zoneInterpolationCbLabel: {
        id: "eventModule.eventInfo.zoneInterpolationCbLabel",
        defaultMessage: "Zone Interpolation",
    },
    zoneSamplingCbLabel: {
        id: "eventModule.eventInfo.zoneSamplingCbLabel",
        defaultMessage: "Zone Sampling",
    },
});
